(function () {
  function initProduct(root) {
    var variants = JSON.parse(root.getAttribute('data-variants') || '[]');
    var form = root.querySelector('[data-eyeurl-product-form]');
    if (!form || !variants.length) return;
    var idInput = form.querySelector('input[name="id"]');
    var price = root.querySelector('[data-eyeurl-price]');
    var compare = root.querySelector('[data-eyeurl-compare]');
    var selectedOption = root.querySelector('[data-eyeurl-selected-option]');
    var selectedOptionPrice = root.querySelector('[data-eyeurl-selected-price]');
    var add = root.querySelector('[data-eyeurl-add]');
    var addLabel = root.querySelector('[data-eyeurl-add-label]');
    var selectionStatus = root.querySelector('[data-eyeurl-selection-status]');
    var selectedOptionPosition = selectedOption ? Number(selectedOption.getAttribute('data-option-position')) : 1;
    var quantityInput = root.querySelector('[data-eyeurl-quantity-input]');
    var gallery = root.querySelector('[data-eyeurl-gallery-grid]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-eyeurl-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-eyeurl-thumb]'));
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var subtitle = root.querySelector('.eyeurl-product-subtitle');
    var audienceEyebrow = root.querySelector('.eyeurl-product-info__heading-row .eyeurl-product-eyebrow');
    var stickyAtc = root.querySelector('[data-eyeurl-sticky-atc]');
    var stickyAdd = root.querySelector('[data-eyeurl-sticky-add]');
    var stickyLabel = root.querySelector('[data-eyeurl-sticky-label]');
    var stickyPrice = root.querySelector('[data-eyeurl-sticky-price]');
    var stickyOption = root.querySelector('[data-eyeurl-sticky-option]');

    if (price) price.setAttribute('aria-live', 'polite');
    if (selectionStatus) selectionStatus.setAttribute('aria-live', 'polite');

    if (variants.length === 1 && variants[0].title === 'Default Title') {
      root.querySelectorAll('[data-eyeurl-option-group]').forEach(function (group) { group.hidden = true; });
    }

    if (subtitle && audienceEyebrow) {
      var audienceText = audienceEyebrow.textContent.trim().toLowerCase();
      if (audienceText.indexOf('women') === 0) subtitle.textContent = 'Women’s reading glasses';
      else if (audienceText.indexOf('men') === 0) subtitle.textContent = 'Men’s reading glasses';
      else if (audienceText.indexOf('unisex') === 0) subtitle.textContent = 'Unisex reading glasses';
      else subtitle.textContent = 'Reading glasses for women & men';
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, moneyFormat);
      return (cents / 100).toFixed(2);
    }
    function inputs() { return Array.prototype.slice.call(root.querySelectorAll('[data-eyeurl-option]')); }
    function selectedOptions() {
      var values = [];
      root.querySelectorAll('[data-eyeurl-option-group]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        values.push(checked ? checked.value : '');
      });
      return values;
    }
    function findVariant(values) {
      return variants.find(function (variant) { return variant.options.every(function (value, index) { return value === values[index]; }); });
    }
    function normalizeImageSrc(src) {
      return String(src || '').split('?')[0].replace(/^https?:/, '');
    }
    function updateAvailability() {
      inputs().forEach(function (input) {
        var values = selectedOptions();
        values[Number(input.getAttribute('data-option-position')) - 1] = input.value;
        var match = findVariant(values);
        input.disabled = !match || !match.available;
      });
    }
    function setActiveThumb(index) {
      thumbs.forEach(function (item) { item.classList.toggle('is-active', Number(item.getAttribute('data-index')) === index); });
    }
    function goTo(index, shouldScroll) {
      if (!slides.length) return;
      var bounded = Math.max(0, Math.min(index, slides.length - 1));
      setActiveThumb(bounded);
      var target = slides[bounded];
      if (shouldScroll !== false && target) {
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      }
    }
    function syncSticky(variant) {
      if (!stickyAtc) return;
      if (!variant) {
        if (stickyAdd) stickyAdd.disabled = true;
        if (stickyLabel) stickyLabel.textContent = 'Select options';
        return;
      }
      if (stickyAdd) stickyAdd.disabled = !variant.available;
      if (stickyLabel) stickyLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (stickyPrice) stickyPrice.innerHTML = formatMoney(variant.price);
      if (stickyOption) {
        var optionText = selectedOptions().filter(Boolean).join(' · ');
        stickyOption.textContent = optionText;
        stickyOption.hidden = !optionText || (variants.length === 1 && variant.title === 'Default Title');
      }
    }
    function applyVariant(variant) {
      if (!variant) {
        add.disabled = true;
        if (addLabel) addLabel.textContent = 'Select an available option';
        if (selectionStatus) selectionStatus.textContent = 'Choose an available option';
        syncSticky(null);
        return;
      }
      idInput.value = variant.id;
      add.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (selectionStatus) selectionStatus.textContent = variant.available ? 'Ready to ship' : 'Currently unavailable';
      if (price) price.innerHTML = formatMoney(variant.price);
      if (selectedOption) selectedOption.textContent = selectedOptions()[selectedOptionPosition - 1] || '';
      if (selectedOptionPrice) selectedOptionPrice.innerHTML = formatMoney(variant.price);
      if (compare) { compare.innerHTML = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : ''; compare.hidden = !(variant.compare_at_price > variant.price); }
      if (variant.featured_image && variant.featured_image.src && gallery) {
        var imageSrc = normalizeImageSrc(variant.featured_image.src);
        var matchingSlide = slides.find(function (slide) {
          var slideSrc = normalizeImageSrc(slide.getAttribute('data-image-src'));
          return slideSrc && (slideSrc === imageSrc || slideSrc.indexOf(imageSrc) !== -1 || imageSrc.indexOf(slideSrc) !== -1);
        });
        if (matchingSlide) {
          var imageIndex = Number(matchingSlide.getAttribute('data-index'));
          goTo(imageIndex, window.matchMedia('(min-width: 750px)').matches);
        }
      }
      if (window.history && window.history.replaceState) window.history.replaceState({}, '', root.getAttribute('data-product-url') + '?variant=' + variant.id);
      updateAvailability();
      syncSticky(variant);
    }
    root.addEventListener('change', function (event) { if (event.target.matches('[data-eyeurl-option]')) applyVariant(findVariant(selectedOptions())); });
    thumbs.forEach(function (thumb) { thumb.addEventListener('click', function () { goTo(Number(thumb.getAttribute('data-index')), true); }); });
    if ('IntersectionObserver' in window && slides.length > 1) {
      var galleryObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setActiveThumb(Number(entry.target.getAttribute('data-index')));
        });
      }, { threshold: 0.55 });
      slides.forEach(function (slide) { galleryObserver.observe(slide); });
    }
    root.querySelectorAll('[data-eyeurl-quantity-change]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!quantityInput) return;
        var current = Math.max(1, Number(quantityInput.value) || 1);
        quantityInput.value = button.getAttribute('data-eyeurl-quantity-change') === 'increase' ? current + 1 : Math.max(1, current - 1);
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        if (!stickyAdd.disabled) add.click();
      });
    }
    function updateStickyVisibility() {
      if (!stickyAtc) return;
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var addRect = add.getBoundingClientRect();
      var passedMainButton = addRect.bottom < 0;
      var nearPageBottom = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 160;
      var showSticky = isMobile && passedMainButton && !nearPageBottom;
      stickyAtc.classList.toggle('is-visible', showSticky);
      stickyAtc.setAttribute('aria-hidden', showSticky ? 'false' : 'true');
      stickyAtc.toggleAttribute('inert', !showSticky);
    }
    if (stickyAtc) {
      window.addEventListener('scroll', updateStickyVisibility, { passive: true });
      window.addEventListener('resize', updateStickyVisibility, { passive: true });
    }
    var initial = variants.find(function (variant) { return String(variant.id) === String(idInput.value); }) || variants.find(function (variant) { return variant.available; }) || variants[0];
    applyVariant(initial);
    updateStickyVisibility();
  }
  document.querySelectorAll('[data-eyeurl-product]').forEach(initProduct);
})();
